import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import {filterUrl, isInternalLink} from "../../helpers/filters";
import './ButtonCard.scss';
import {trackEventByUrl} from "../../helpers/events";

class ButtonCard extends Component {
    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        buttonCard: PropTypes.object.isRequired
    };

    state = {
        backgroundColor: this.props.buttonCard.entity.fieldBackgroundColor
    };

    handleHover = () => {
        const color = Color(this.props.buttonCard.entity.fieldBackgroundColor);
        this.setState({backgroundColor: color.darken(0.3)});
    };

    handleHoverExit = () => {
        this.setState({backgroundColor: this.props.buttonCard.entity.fieldBackgroundColor});
    };

    render() {
        const {buttonCard} = this.props;

        const linkIsInternal = isInternalLink(buttonCard.entity.fieldLink.url.path);

        return (
            <a href={filterUrl(buttonCard.entity.fieldLink.url.path)}
               target={linkIsInternal ? '_self' : '_blank'}
               rel={linkIsInternal ? null : 'noopener noreferrer'}
               className="buttonCard button"
               onMouseOver={this.handleHover}
               onMouseOut={this.handleHoverExit}
               onClick={() => trackEventByUrl(buttonCard.entity.fieldLink.url.path, buttonCard.entity.fieldTxtHeadline || 'Button Card')}
               style={{
                   backgroundColor: this.state.backgroundColor,
                   color: buttonCard.entity.fieldTextColor
               }}
            >

                {buttonCard.entity.fieldTxtHeadline && (
                    <h3 className="buttonCard__headline">
                        {buttonCard.entity.fieldTxtHeadline}
                    </h3>
                )}

                {buttonCard.entity.fieldTxtSubTitle && (
                    <p className="buttonCard__subheadline">
                        {buttonCard.entity.fieldTxtSubTitle}
                    </p>
                )}

            </a>
        );
    }
}

export default ButtonCard;



// WEBPACK FOOTER //
// ./frontend/components/ButtonCards/ButtonCard.jsx